//LOGO
export const LOGO = '/assets/svg/logo.svg'

//SITE NAME
export const SITE_NAME = 'Nellis Auction'

// SIDE PANEL LIST
export const SIDE_PANEL = [
    {
        label: 'Dashboard',
        path: '/dashboard',
        type: 'single',
    },
    {
        label: 'Auction Lots',
        path: '/auction/all',
        type: 'single',
    },
    {
        label: 'Listing',
        type: 'multiple',
        path: 'listing',
        subLinks: [
            {
                label: 'Active',
                path: '/listing/open',
            },
            {
                label: 'Sold',
                path: '/listing/sold',
            },
            {
                label: 'Unsold',
                path: '/listing/unsold',
            },
            {
                label: 'Draft',
                path: '/listing/draft',
            },
        ],
    },
    {
        label: 'User',
        path: 'users',
        type: 'multiple',
        subLinks: [
            {
                label: 'All ',
                path: '/users/all',
            },
            {
                label: 'Active',
                path: '/users/active',
            },
            {
                label: 'Not Bid',
                path: '/users/not_bid',
            },
            {
                label: 'Deactivated',
                path: '/users/deactivate',
            },
        ],
    },
    // {
    //     label: 'Invoice',
    //     path: 'invoice',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Unpaid',
    //             path: '/invoice/unpaid',
    //         },
    //         {
    //             label: 'Paid',
    //             path: '/invoice/paid',
    //         },
    //     ],
    // },
    {
        label: 'Return',
        path: 'return',
        type: 'multiple',
        subLinks: [
            {
                label: 'Pending',
                path: '/return/pending',
            },
            {
                label: 'Completed',
                path: '/return/completed',
            },
        ],
    },
    {
        label: 'Transactions',
        path: 'transaction',
        type: 'multiple',
        subLinks: [
            {
                label: 'Payment',
                path: '/transaction/payment',
            },
            {
                label: 'Receipts',
                path: '/transaction/receipts',
            },
            // {
            //     label: 'Refund',
            //     path: '/transaction/refund',
            // },
        ],
    },
    {
        label: 'Employee',
        path: 'employees',
        type: 'multiple',
        subLinks: [
            {
                label: 'All',
                path: '/employees/all',
            },
        ],
    },

    {
        label: 'Report',
        path: '/report',
        type: 'single',
    },
    {
        label: 'Communications',
        path: 'communications',
        type: 'multiple',
        subLinks: [
            {
                label: 'Email Template',
                path: '/communications/email',
            },
            {
                label: 'SMS Template',
                path: '/communications/sms',
            },
            {
                label: 'Email Logs',
                path: '/communications/emailLogs',
            },
        ],
    },
    // {
    //   label: "Language Manager",
    //   path: "/languageManager",
    //   type: "single",
    // },
    {
        label: 'Settings',
        path: 'settings',
        type: 'multiple',
        subLinks: [
            {
                label: 'Static Pages',
                path: '/settings/static',
            },
            {
                label: 'General Settings',
                path: '/settings/general',
            },
            {
                label: 'Bid Increments',
                path: '/settings/bid_increments',
            },
            {
                label: 'Banners',
                path: '/settings/banners',
            },
        ],
    },
]

export const ALL_PAGINATION = [
    {
        value: '20',
        show: '20 Results per page',
    },
    {
        value: '40',
        show: '40 Results per page',
    },
    {
        value: '60',
        show: '60 Results per page',
    },
]
